import { render, staticRenderFns } from "./serviceFeedback.vue?vue&type=template&id=d2e9296e"
import script from "./serviceFeedback.vue?vue&type=script&lang=js"
export * from "./serviceFeedback.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports